export var PIXEL_RATIO = window.devicePixelRatio || 1;
var Canvas = /** @class */ (function () {
    function Canvas(width, height) {
        if (DEVELOPMENT) {
            if (!/\.0$/.test(width.toFixed(1)) || !/\.0$/.test(height.toFixed(1))) {
                console.warn("\u041D\u0435 \u0446\u0435\u043B\u044B\u0435 width/height Canvas");
            }
        }
        this.width = width;
        this.height = height;
        this.canvas = document.createElement('CANVAS');
        this.ctx = this.canvas.getContext('2d');
        this.ctx.scale(PIXEL_RATIO, PIXEL_RATIO);
        this.resize(width, height);
    }
    Canvas.prototype.resize = function (width, height) {
        this.width = width;
        this.height = height;
        this.canvas.width = width * PIXEL_RATIO;
        this.canvas.height = height * PIXEL_RATIO;
        this.canvas.style.width = width + 'px';
        this.canvas.style.height = height + 'px';
    };
    Canvas.prototype.fillStyle = function (style) {
        this.ctx.fillStyle = style;
    };
    Canvas.prototype.strokeStyle = function (style) {
        this.ctx.strokeStyle = style;
    };
    Canvas.prototype.shadowColor = function (color) {
        this.ctx.shadowColor = color;
    };
    Canvas.prototype.shadowBlur = function (shadowBlur) {
        this.ctx.shadowBlur = shadowBlur * PIXEL_RATIO;
    };
    Canvas.prototype.lineWidth = function (lineWidth) {
        this.ctx.lineWidth = lineWidth * PIXEL_RATIO;
    };
    Canvas.prototype.font = function (size, name, weight) {
        if (name === void 0) { name = 'Arial'; }
        size = size * PIXEL_RATIO;
        this.ctx.font = weight ? "".concat(weight, " ").concat(size, "px ").concat(name) : "".concat(size, "px ").concat(name);
    };
    Canvas.prototype.fillText = function (text, x, y) {
        this.ctx.fillText(text, x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.strokeText = function (text, x, y, maxWidth) {
        this.ctx.strokeText(text, x * PIXEL_RATIO, y * PIXEL_RATIO, maxWidth * PIXEL_RATIO);
    };
    Canvas.prototype.fillCenterText = function (text, y) {
        var x = this.width / 2 - this.textWidth(text) / 2;
        this.ctx.fillText(text, x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.fillRightText = function (text, y, paddingRight) {
        if (paddingRight === void 0) { paddingRight = 0; }
        var x = this.width - this.textWidth(text) - paddingRight;
        this.ctx.fillText(text, x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.text = function (text, props) {
        var x = (props && props.x) || 0;
        var y = (props && props.y) || props.fontSize;
        var maxWidth = (props && props.maxWidth) || this.width;
        var alignRight = props.align && props.align === 'right';
        var words = text.split(' ');
        var spaceWidth = this.textWidth(' ');
        var lines = [];
        var line = '';
        var lineWidth = 0;
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            var wordWidth = this.textWidth(word);
            if (lineWidth + wordWidth + spaceWidth + x > maxWidth) {
                lines.push(line);
                line = '';
                lineWidth = 0;
            }
            lineWidth += line ? wordWidth + spaceWidth : wordWidth;
            line += line ? " ".concat(word) : word;
        }
        if (line) {
            lines.push(line);
        }
        for (var i = 0; i < lines.length; i++) {
            var line_1 = lines[i];
            var textX = alignRight ? this.width - this.textWidth(line_1) - x : x;
            this.ctx.fillText(line_1, textX * PIXEL_RATIO, y * PIXEL_RATIO);
            y += 1.2 * props.fontSize;
        }
    };
    Canvas.prototype.textWidth = function (text) {
        var width = this.ctx.measureText(text).width;
        return width / PIXEL_RATIO;
    };
    Canvas.prototype.beginPath = function () {
        this.ctx.beginPath();
    };
    Canvas.prototype.closePath = function () {
        this.ctx.closePath();
    };
    Canvas.prototype.fill = function () {
        this.ctx.fill();
    };
    Canvas.prototype.moveTo = function (x, y) {
        this.ctx.moveTo(x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.lineTo = function (x, y) {
        this.ctx.lineTo(x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.quadraticCurveTo = function (cpx, cpy, x, y) {
        this.ctx.quadraticCurveTo(cpx * PIXEL_RATIO, cpy * PIXEL_RATIO, x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.save = function () {
        this.ctx.save();
    };
    Canvas.prototype.restore = function () {
        this.ctx.restore();
    };
    Canvas.prototype.translate = function (x, y) {
        this.ctx.translate(x * PIXEL_RATIO, y * PIXEL_RATIO);
    };
    Canvas.prototype.rotate = function (angle) {
        this.ctx.rotate(angle);
    };
    Canvas.prototype.scale = function (x, y) {
        this.ctx.scale(x, y);
    };
    Canvas.prototype.fillRect = function (x, y, width, height, color) {
        if (color) {
            this.ctx.fillStyle = color;
        }
        this.ctx.fillRect(x * PIXEL_RATIO, y * PIXEL_RATIO, width * PIXEL_RATIO, height * PIXEL_RATIO);
    };
    Canvas.prototype.fillAll = function (color) {
        this.ctx.fillStyle = color;
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    };
    Canvas.prototype.strokeRect = function (x, y, width, height, color, lineWidth) {
        if (lineWidth === void 0) { lineWidth = 1; }
        if (color) {
            this.ctx.strokeStyle = color;
        }
        this.lineWidth(lineWidth);
        this.ctx.strokeRect(x * PIXEL_RATIO, y * PIXEL_RATIO, width * PIXEL_RATIO, height * PIXEL_RATIO);
    };
    Canvas.prototype.strokeCircle = function (x, y, radius, color, lineWidth) {
        if (color === void 0) { color = '#FFFFFF'; }
        if (lineWidth === void 0) { lineWidth = 1; }
        this.ctx.beginPath();
        this.ctx.strokeStyle = color;
        this.lineWidth(lineWidth);
        this.ctx.arc(x * PIXEL_RATIO, y * PIXEL_RATIO, radius * PIXEL_RATIO, 0, Math.PI * 2);
        this.ctx.stroke();
        this.ctx.closePath();
    };
    Canvas.prototype.fillCircle = function (x, y, radius, color) {
        this.ctx.beginPath();
        if (color)
            this.ctx.fillStyle = color;
        this.ctx.arc(x * PIXEL_RATIO, y * PIXEL_RATIO, radius * PIXEL_RATIO, 0, Math.PI * 2);
        this.ctx.fill();
        this.ctx.closePath();
    };
    Canvas.prototype.createLinearGradient = function (x0, y0, x1, y1) {
        return this.ctx.createLinearGradient(x0 * PIXEL_RATIO, y0 * PIXEL_RATIO, x1 * PIXEL_RATIO, y1 * PIXEL_RATIO);
    };
    Canvas.prototype.fillArc = function (x, y, radius, startAngle, endAngle, color) {
        if (color === void 0) { color = '#FFFFFF'; }
        this.ctx.beginPath();
        this.ctx.fillStyle = color;
        this.arc(x, y, radius, startAngle, endAngle);
        this.ctx.fill();
        this.ctx.closePath();
    };
    Canvas.prototype.arc = function (x, y, radius, startAngle, endAngle, anticlockwise) {
        this.ctx.arc(x * PIXEL_RATIO, y * PIXEL_RATIO, radius * PIXEL_RATIO, startAngle, endAngle, anticlockwise);
    };
    Canvas.prototype.clear = function (x, y, w, h) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        if (w === void 0) { w = this.canvas.width; }
        if (h === void 0) { h = this.canvas.height; }
        this.ctx.clearRect(x * PIXEL_RATIO, y * PIXEL_RATIO, w * PIXEL_RATIO, h * PIXEL_RATIO);
    };
    Canvas.prototype.clearRect = function (x, y, w, h) {
        this.ctx.clearRect(x * PIXEL_RATIO, y * PIXEL_RATIO, w * PIXEL_RATIO, h * PIXEL_RATIO);
    };
    Canvas.prototype.drawImage = function (source, sx, sy, sw, sh, dx, dy, dw, dh) {
        var isNotImage = source.constructor !== HTMLImageElement;
        if (isNotImage) {
            sx = sx * PIXEL_RATIO;
            sy = sy * PIXEL_RATIO;
        }
        if (sw === undefined) {
            return this.ctx.drawImage(source, sx, sy);
        }
        if (isNotImage) {
            sw = sw * PIXEL_RATIO;
            sh = sh * PIXEL_RATIO;
        }
        if (dx === undefined) {
            return this.ctx.drawImage(source, sx, sy, sw, sh);
        }
        dx = dx * PIXEL_RATIO;
        dy = dy * PIXEL_RATIO;
        dw = dw * PIXEL_RATIO;
        dh = dh * PIXEL_RATIO;
        this.ctx.drawImage(source, sx, sy, sw, sh, dx, dy, dw, dh);
    };
    Canvas.prototype.size = function () {
        return { width: this.width, height: this.height };
    };
    Canvas.prototype.createRadialGradient = function (x1, y1, r1, x2, y2, r2) {
        x1 = x1 * PIXEL_RATIO;
        y1 = y1 * PIXEL_RATIO;
        r1 = r1 * PIXEL_RATIO;
        x2 = x2 * PIXEL_RATIO;
        y2 = y2 * PIXEL_RATIO;
        r2 = r2 * PIXEL_RATIO;
        return this.ctx.createRadialGradient(x1, y1, r1, x2, y2, r2);
    };
    Canvas.prototype.draw3dText = function (options) {
        var text = options.text, x = options.x, y = options.y, textDepth = options.textDepth, fontSize = options.fontSize, fontFamily = options.fontFamily, color = options.color, shadowColor = options.shadowColor;
        this.ctx.save();
        this.ctx.fillStyle = color;
        this.ctx.font = "".concat(fontSize * PIXEL_RATIO, "px ").concat(fontFamily || 'Arial');
        var dx = this.textWidth(text) / 2;
        for (var n = 0; n < textDepth; n++) {
            this.ctx.fillText(text, (x - n - dx) * PIXEL_RATIO, (y - n) * PIXEL_RATIO);
        }
        this.ctx.fillStyle = color;
        this.ctx.shadowColor = shadowColor;
        this.ctx.shadowBlur = 10 * PIXEL_RATIO;
        this.ctx.shadowOffsetX = (textDepth + 2) * PIXEL_RATIO;
        this.ctx.shadowOffsetY = (textDepth + 2) * PIXEL_RATIO;
        this.ctx.fillText(text, (x - textDepth - dx) * PIXEL_RATIO, (y - textDepth) * PIXEL_RATIO);
        this.ctx.restore();
    };
    return Canvas;
}());
export { Canvas };
